/**
 * @module utils/uid
 */
const { crypto } = globalThis
const uids = new WeakMap()

const reserved = target => {
  if (!uids.has(target)) {
    uids.set(target, new Set())
  }
  
  return uids.get(target)
}

/**
 * @param {object} target
 * @returns {string}
 */
export const register = (
  target
) => {
  const values = new Uint32Array(6)
  const uids = reserved(target)
  
  while (true) {
    const uid = crypto.getRandomValues(values).join('-')
    
    if (!uids.has(uid)) {
      uids.add(uid)
      
      return uid
    }
  }
}

/**
 * @param {object} target
 * @param {string} uid
 */
export const unregister = (
  target,
  uid
) => {
  uids.get(target)?.delete(uid)
}
